<template>
    <div class="task-type">
        <headers title='选择作业类型'
                 :is_finish='is_finish'></headers>
        <div class="typeList"
             v-if="typeList.length">
            <div class="item"
                 v-for="(item,index) in typeList"
                 :key="index">
                <div class="item-name">
                    {{item.type_title}}
                </div>
                <div class="sub-item"
                     v-for="(item2,index2) in item.type_child"
                     @click="handleSelectChapter(item2)"
                     :key="index2">
                    <img :src="item2.img"
                         class="icon">
                    <div class="text">
                        <h2>{{item2.name}}</h2>
                    </div>
                    <img src="./img/icon_next.png"
                         class="arrow"
                         >
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue'
export default {
    data () {
        return {
            is_finish: localStorage.getItem('subjectLength') <= 1,//从本地读取教师带的科目数并判断
            typeList:[
               {
                type_title:'爱尚围棋',
                type_child:[
                    {   
                        img:require('./img/icon_img2.png'),
                        name:'围棋课后练习',
                        type:1,
                    }
                ]
               }
            ]
        }
    },
    components: {
        headers
    },
    created () {

    },
    methods: {
        handleSelectChapter(){
            this.$router.push('/weiqi/selectChapter')
        }
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.task-type {
    min-height: 100vh;
    .header {
        background: #5e89ef;
        .left {
            display: block;
            width: 18px / $ppr;
            height: 34px / $ppr;
            background: url("./img/choose_back.png") 0 0 no-repeat;
            background-size: 100% 100%;
        }
    }
}
.typeList {
    .item {
        background: #fff;
        margin-bottom: 20px / $ppr;

        .item-name {
            font-size: 30px / $ppr;
            font-weight: bold;
            padding: 28px / $ppr 0 28px / $ppr 24px / $ppr;
            display: flex;
            align-items: center;
            &:before {
                content: "";
                display: block;
                width: 4px / $ppr;
                height: 32px / $ppr;
                background: #5e89ef;
                margin-right: 16px / $ppr;
            }
            img {
                margin-left: 5px / $ppr;
                width: 64px / $ppr;
                height: 30px / $ppr;
            }
        }
        .sub-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 34px / $ppr 24px / $ppr;
            border-top: 1px / $ppr solid #e8e8e8;
            .icon {
                width: 50px / $ppr;
                height: 50px / $ppr;
            }
            .text {
                flex: 1;
                margin-left: 20px / $ppr;
                h2 {
                    font-size: 30px / $ppr;
                    font-weight: normal;
                }
            }
            .arrow {
                width: 14px / $ppr;
                height: 26px / $ppr;
            }
        }
    }
}
</style>
